module.exports = {
    AUTH:'/auth',
    MEET:'/meet',
    ROOM:'/room',
    OAUTH:'/oauth'
}